import axios from 'axios';

// Determine the API base URL based on environment
const getApiBaseUrl = () => {
  // Check if we're in production by looking at the current URL
  const isProduction = window.location.hostname !== 'localhost' && 
                      window.location.hostname !== '127.0.0.1' &&
                      !window.location.hostname.includes('localhost');
  
  // Force localhost for development
  if (!isProduction) {
    console.log('🔧 Using localhost for development');
    return 'http://localhost:5001';
  }
  
  // Only use production URL if explicitly set
  if (process.env.REACT_APP_API_URL) {
    console.log('🔧 Using REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
    return process.env.REACT_APP_API_URL;
  }
  
  // Production fallback - always use Railway URL for reliability
  console.log('🔧 Using Railway production URL for reliability');
  return 'https://sabiwabeeai-production.up.railway.app';
};

const API_BASE_URL = getApiBaseUrl();

// Debug logging
console.log('🔧 API Configuration Debug:');
console.log('NODE_ENV:', process.env.NODE_ENV);
console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
console.log('API_BASE_URL:', API_BASE_URL);
console.log('Current hostname:', window.location.hostname);

// Create axios instance with default configuration
const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  timeout: 60000, // Increased timeout to 60 seconds for mobile networks
  headers: {
    'Content-Type': 'application/json',
  },
  // Add retry configuration for mobile networks
  retry: 3,
  retryDelay: 1000,
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Add mobile-specific headers
    config.headers['X-Device-Type'] = 'mobile';
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    
    console.log('🔧 API Request:', config.method?.toUpperCase(), config.url);
    return config;
  },
  (error) => {
    console.error('🔧 API Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    console.log('🔧 API Response:', response.status, response.config.url);
    return response;
  },
  (error) => {
    console.error('🔧 API Response Error:', error);
    console.error('🔧 Error Status:', error.response?.status);
    console.error('🔧 Error Message:', error.message);
    
    // Handle network errors specifically
    if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
      console.error('🔧 Network timeout - this might be a mobile network issue');
      return Promise.reject({
        ...error,
        message: 'Network timeout. Please check your connection and try again.'
      });
    }
    
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    
    // Handle CORS errors
    if (error.message.includes('Network Error') || error.message.includes('CORS')) {
      console.error('🔧 CORS or Network Error detected');
      return Promise.reject({
        ...error,
        message: 'Network error. Please check your connection and try again.'
      });
    }
    
    return Promise.reject(error);
  }
);

export default api;
export { API_BASE_URL }; 